const resources = {
    searchTitle: 'Search photos & videos',
    explore: 'Explore',
    uploadToGallery: '+ Upload to Gallery'
};

module.exports = function getResource(label) {
    return resources[label];
};
